export default JSON.stringify({
  data: {
    token: 'mocked-token-updated',
  },
})
